import format from 'date-fns/format';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import RadioCard from 'components/CncUI/RadioCard';
import Typography from 'components/CncUI/Typography';
import parseAddress from '../utils/parseAddress';
import parseCorpType from '../utils/parseCorpType';

const useStyles = makeStyles(({ palette }) => ({
  green: {
    color: palette.cncUI.default.primary,
  },
}));

const LABELS = {
  1: 'CAPS Profile',
  2: 'Cast & Crew Profile',
  16: 'Media Services Profile',
};

const ExistingCard = ({ data, value, disabled, country }) => {
  const classes = useStyles();
  const rowValue = (label, value) => (
    <Grid item xs={12}>
      <Typography body1 short noMargin className={classes.green}>
        {label}
      </Typography>
      <Typography body2 short noMargin>
        {value}
      </Typography>
    </Grid>
  );
  return (
    <RadioCard
      value={value}
      disabled={disabled}
      label={LABELS[data.dataSource] || 'Unknown Profile'}
      style={{ maxWidth: 365, height: 385 }}
    >
      <Grid container spacing={1}>
        {rowValue('FEIN', `*****${data.taxId.slice(-4)}`)}
        {rowValue('Entity Name', data.name)}
        {country !== 'CAN'
          ? rowValue('Entity Type', parseCorpType(data.type) || <>&nbsp;</>)
          : null}
        {rowValue('Entity Address', parseAddress(data))}
        {rowValue(
          'Loan-out Last Updated',
          data.createdAt ? (
            format(
              new Date(
                new Date(parseInt(data.createdAt, 10))
                  .toISOString()
                  .slice(0, -1),
              ),
              'PPpp',
            )
          ) : (
            <>&nbsp;</>
          ),
        )}
      </Grid>
    </RadioCard>
  );
};

export default ExistingCard;
